<script>
export default {
    name: "VStageProgress",
    props: {
        stages: {
            type: Array,
            required: true,
            description: "Array of stage objects with {name, status, icon}"
        }
    },
    methods: {
        getStatusClass(status) {
            return `stage-${status}`;
        },
        handleLinkClick() {
            this.$emit("link-click");
        }
    }
};
</script>

<template>
    <div class="v-stage-progress">
        <div class="stages-container">
            <template v-for="(stage, index) in stages">
                <!-- Stage item -->
                <div :key="`stage-${index}`" class="stage-item">
                    <div
                        class="stage-icon"
                        :class="getStatusClass(stage.status)"
                    >
                        <i :class="stage.icon"></i>
                    </div>
                    <div class="stage-name">{{ stage.name }}</div>
                </div>

                <!-- Connecting line after stage (except last) -->
                <div
                    v-if="index < stages.length - 1"
                    :key="`line-${index}`"
                    class="stage-line"
                ></div>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.v-stage-progress {
    display: flex;
    align-items: center;
    padding: 20px 0;

    .stages-container {
        display: flex;
        align-items: center;
        width: 100%;
    }

    .stage-line {
        flex: 1;
        height: 2px;
        background-color: #d1d5db;
    }

    .stage-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        white-space: nowrap;
        flex-shrink: 0;
    }

    .stage-icon {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;

        &.stage-completed {
            background-color: #789e6b;
            color: white;
        }

        &.stage-active {
            background-color: #f59e0b;
            color: #f59e0b;
        }

        &.stage-pending {
            background-color: transparent;
            border: 2px solid #9ca3af;
            color: transparent;
        }
    }

    .stage-name {
        margin-top: 8px;
        font-size: 14px;
        color: #374151;
        font-weight: 600;
    }

    .stage-link {
        margin-left: 20px;
        white-space: nowrap;

        a {
            color: #3b82f6;
            text-decoration: none;
            font-size: 14px;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
